export default __webpack_public_path__ + "static/media/group-option-gender-unselected.a32ecd72.svg";